<template>
  <WhitePage :loading="$store.getters.loading">
    <b-img src="./img/title2.png" fluid />
    <b-container>
      <b-row>
        <b-col sm>

          <p>
            奇跡が起こらないと噂で
          </p>
          <p>
            そうでいながら平和で
          </p>
          <p>
            それでいてどこか儚い
          </p>
          <p>
            そんな世界でのんびりお散歩しませんか
          </p>

          <b-alert show variant="info">
            現在新規登録受付中です。
            <router-link to="/help">概要・ルールはこちら</router-link>
          </b-alert>

          <b-img class="banner" src="./img/banner.png" />

        </b-col>
        <b-col sm>

          <b-form style="border: solid 1px #000; padding: 5px;">
            <b-form-group id="eno" label="ENo"
            >
              <b-form-input v-model="form.eno"></b-form-input>
            </b-form-group>
            <b-form-group id="password" label="Password"
            >
              <b-form-input v-model="form.password"
                type="password"
              />
            </b-form-group>
            <b-form-group>
              <b-button type="button" @click="onSubmit" variant="primary">ログイン</b-button>
              <b-button type="button" @click="$router.push({ path:'new' })">新規登録</b-button>
            </b-form-group>
            <b-form-group label="Twitterからログイン"
              description="アカウント作成後、Twitterアカウントと連携すると、ENo・Password入力を省略できます。">
              <b-button @click="twitter()"><img :src="require('@/assets/ui/sign-in-with-twitter.png')" /></b-button>
            </b-form-group>
            <response-message :value="postMessage" />
          </b-form>
          
        </b-col>
      </b-row>
    </b-container>
  </WhitePage>
</template>

<script>
// import phina from 'phina.js'
import WhitePage from '@/components/WhitePage'
// import TitleBar from '@/components/TitleBar'
import ResponseMessage from '@/components/ResponseMessage'
export default {
  components: {
    WhitePage,
    // TitleBar,
    ResponseMessage
  },
  data () {
    return {
      form: { eno: '', password: '' },
      postMessage: {}
    }
  },
  methods: {
    onSubmit () {
      this.$store.dispatch('login', this.form)
        .then((response) => {
          this.postMessage = response
          if(response.error === '200 OK'){
            this.$store.commit('LOGIN')
            this.$router.push({ path: 'result' })
          }
        })
    },
    twitter () {
      this.$store.dispatch('signInTwitter', 'loginTwitter')
        .then((response)=>{
          window.location = response.url
        })
    }
  },
  mounted () {
    this.$store.dispatch('logout')
  }
}
</script>

<style scoped lang="scss">
.banner {
  padding: 10px;
}
</style>
